import {MyopIframeComponent} from "../components/myopIframeComponent";
import {BaseMyopLoader} from "./IMyopLoader";
import {uuidv4} from "../../utils/utils";
import {loaderOptions} from "../hostSDK";
import {IComponentDefinitionConfig, IIframeLoaderConfig, ISkinConfig, SkinLoaders} from "../../common";

const addQueryParam = (url: string, param: string, value: string) => {
    // Create a URL object
    const urlObj = new URL(url);

    // Add the query parameter
    urlObj.searchParams.append(param, value);

    // Return the updated URL
    return urlObj.toString();
}

export class MyopIframeLoader extends BaseMyopLoader {
    type = SkinLoaders.IframeLoader

    // @ts-ignore
    load = async (componentDefinition: IComponentDefinitionConfig, skin: ISkinConfig, container: HTMLElement, options?: loaderOptions) => {
        let IframeElement: HTMLIFrameElement;

        const typedLoaderConfig = (skin.loader as IIframeLoaderConfig);

        if (container?.nodeName === "IFRAME") {
            console.log('needs to load into an exsisting Iframe...', typedLoaderConfig.url, container);

            IframeElement = (container as HTMLIFrameElement)
            IframeElement.src = typedLoaderConfig.url
        } else {
            const uniqId = uuidv4();
            const domId = `myop-comp-${uniqId}`

            IframeElement = document.createElement('iframe');
            IframeElement.id = domId;

            // Set all styles BEFORE appending to prevent flash at wrong position
            const iframeStyles = `
                padding: 0;
                margin: 0;
                position: absolute;
                inset: 0;
                height: ${typedLoaderConfig.autoHeight || !typedLoaderConfig.height ? '100%' : typedLoaderConfig.height};
                width: 100%;
                overflow: hidden;
                border: none;
                opacity: ${options?.hidden ? '0' : '1'};
                pointer-events: ${options?.hidden ? 'none' : 'all'};
            `;
            IframeElement.style.cssText = iframeStyles;

            // Set element attributes if provided
            if (options?.elementAttributes) {
                Object.entries(options.elementAttributes).forEach(([key, value]) => {
                    if (value === '' || value === null || value === undefined) {
                        IframeElement.setAttribute(key, '');
                    } else {
                        IframeElement.setAttribute(key, String(value));
                    }
                });
            }

            // in order to handle issue to load iframe inside an iframe with the same url
            let url2load = (skin.loader as IIframeLoaderConfig).url;
            if (options?._hasParent)
                url2load = addQueryParam(url2load, "_myop-comp", uniqId);

            IframeElement.src = url2load;

            // TODO : do it only with flag ?
            if (!container.querySelector('[id^="myop-comp-"]'))
                container.innerHTML = '';

            IframeElement = this.appendChild(container, IframeElement, options) as HTMLIFrameElement;
            //   IframeElement = document.getElementById(domId) as HTMLIFrameElement;
            //NO : IframeElement = container.lastElementChild as HTMLIFrameElement;
        }

        return new MyopIframeComponent(componentDefinition, skin, container, IframeElement, options);
    }
}
